'use client';

import { Menu } from 'lucide-react';

import { useHeaderStore } from '@lib/stores/useHeaderStore';
import { Button } from '@components/common/button';

export function LowerHeaderHamburgerMenu() {
  const setOpenSheet = useHeaderStore((state) => state.setOpenSheet);

  return (
    <Button
      type='button'
      className='text-primary-foreground/80 hover:text-primary-foreground [&_svg]:size-6 p-0 size-auto'
      onClick={() => setOpenSheet(true)}
    >
      <span className='sr-only'>Open menu</span>
      <Menu aria-hidden='true' />
    </Button>
  );
}
